module.exports = __webpack_public_path__ + "img/2.aa5cb342.png";